<template>
  <div class="fre-main">
    <div class="left-container">
      <div class="date-refresh-section">
        <div class="from-to-date">
          <DateTimePicker title="From" :showTime="false" :value.sync="selectedFromDate" :errorMessage.sync="fromDateError" />
          <DateTimePicker title="To" :showTime="false" :value.sync="selectedToDate" :errorMessage.sync="toDateError" />
        </div>
        <button @click="refreshClicked">Refresh</button>
      </div>
      
      <Dropdown placeholder="System" :items="systemItems" itemKey="Application Name" :selectedObject.sync="selectedSystem" style="margin: 10px 0"
        :errorMessage.sync="systemError" />
      <Dropdown placeholder="Job Type" :items="jobType" itemKey="Description" :selectedObject.sync="selectedJobType" style="margin: 10px 0"
        :errorMessage.sync="jobError" />

      <Filters class="customer-filter" title="Customer" :tableData="customerItems" itemKey="Customer Code" itemDesc="Customer Name"
        @confirmClicked="filterConfirm"/>
    </div>

    <div class="right-container">
      <div class="filter-section">
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Job Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="`${filteredFromDate} to ${filteredToDate}`" v-if="filteredFromDate">{{ filteredFromDate }} to {{ filteredToDate }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">System</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredSystem.System ? filteredSystem.System.trim() : ''">{{ filteredSystem.System ? filteredSystem.System.trim() : '' }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Job Type</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredJobType['Description'] == 'All' ? 'All' : filteredJobType['Job Type'] ? filteredJobType['Job Type'].trim() : ''">{{ filteredJobType['Description'] == 'All' ? 'All' : filteredJobType['Job Type'] ? filteredJobType['Job Type'].trim() : '' }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Customer</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredCustomers.length == 0 ? 'All' : filteredCustomers.map((s) => { return s['Customer Code'] }).join(', ')">{{ filteredCustomers.length == 0 ? 'All' : filteredCustomers.map((s) => { return s['Customer Code'] }).join(',') }}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div >Last Refreshed : {{ lastRefreshed }}</div>
        </div>
      </div>
      <div class="mid-chart-section">
        <div class="job-type-tues">
          <PieChart pieID="jobPie" :items="TEUsJobItems" itemName="XAxisDesc" itemValue="TEUs" ref="jobPie" pieTitle="TEUs by Job Type"
            hoverFormat="[key] details<br />TEUs: [TEUs]<br />Total 20: [Total20]<br />Total 40: [Total40]<br />[value] ([perc])" tooltipWidth="250" />
        </div>
        <div class="cont-type-tues">
          <PieChart pieID="contPie" :items="TEUsContItems" itemName="XAxisDesc" itemValue="TEUs" ref="contPie" pieTitle="TEUs by Container Type"
          @contextMenuClicked="contTypeContextMenu" :contextMenu="[ 'Drill Through' ]" contextMenuWidth="200" />
        </div>
        <div class="cont-throughput">
          <BarLineChart chartID="monthlyThroughput" :items="monthlyThroughput" :barKeys="[ 'Total20', 'Total40' ]" :lineKeys="[ 'TEUs' ]" xAxisKey="XAxisDesc" ref="contChart"
            chartTitle="Monthly Container Throughput" tooltipFormat="[key] has [value] container on [XAxisDesc]" :contextMenu="[ 'Open Details', 'Drill Through' ]"
            @contextMenuClicked="monthlyThroughputContextMenu" tooltipWidth="200" contextMenuWidth="150" />
        </div>
      </div>
      <div class="bottom-chart-section">
        <!-- <BarLineChart chartID="shprCsgn" :items="top50ShprCsgn" :barKeys="[ 'TEUs' ]" xAxisKey="XAxis" ref="shprCsgn"
          chartTitle="Monthly Container Throughput" :contextMenu="[ 'Drill Through' ]" :isHorizontal="true" /> -->
        <BarLineChart chartID="shprCsgn" :items="top50ShprCsgn" :barKeys="salesBarKey" :lineKeys="salesLineKey" xAxisKey="Month Name" ref="shprCsgn"
          chartTitle="Total Sales vs Collection by Sales Person" yAxisWidth="45" :matchBarLine="true"
          tooltipFormat="[key]<br />[Currency] [value]" tooltipWidth="150" :matchBarLineLegend="[ 'Sales', 'Collection' ]" />
      </div>
    </div>

    <Loader :isVisible.sync="loading" :loadingText="loadText" />
  </div>
</template>

<script>
/* eslint-disable */
import Loader from '@/components/Loader.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Dropdown from '@/components/Dropdown.vue';
import Tabulator from '@/components/Tabulator.vue';
import CheckBox from '@/components/CheckBox.vue';
import Filters from '@/components/Filters.vue';
import BarLineChart from '@/components/charts/BarLineChart.vue';
import PieChart from '@/components/charts/PieChart.vue';

export default {
  components: {
    Loader, DateTimePicker, Dropdown, Tabulator, CheckBox, Filters, BarLineChart, PieChart
  },
  props: {
    loading: { type: Boolean, default: false },
    loadText: { type: String, default: '' },

    selectedToDate: { type: Date, default: null },
    selectedFromDate: { type: Date, default: null },
    filteredFromDate: { type: String, default: '' },
    filteredToDate: { type: String, default: '' },
    
    fromDateError: { type: String, default: '' },
    toDateError: { type: String, default: '' },

    systemItems: { type: Array, default: function() { return [] } },
    selectedSystem: { type: Object, default: function() { return null } },
    filteredSystem: { type: Object, default: function() { return {} } },
    systemError: { type: String, default: '' },

    jobType: { type: Array, default: function() { return [] } },
    selectedJobType: { type: Object, default: function() { return null } },
    filteredJobType: { type: Object, default: function() { return {} } },
    jobError: { type: String, default: '' },

    customerItems: { type: Array, default: function() { return [] } },
    selectedCustomers: { type: Array, default: function() { return [] } },
    filteredCustomers: { type: Array, default: function() { return [] } },

    TEUsJobItems: { type: Array, default: function() { return [] } },
    TEUsContItems: { type: Array, default: function() { return [] } },
    
    monthlyThroughput: { type: Array, default: function() { return [] } },

    top50ShprCsgn: { type: Array, default: function() { return [] } },
    salesBarKey: { type: Array, default: function() { return [] } },
    salesLineKey: { type: Array, default: function() { return [] } },

    lastRefreshed: { type: String, default: '' },
  },
  methods: {
    refreshClicked: async function() {
      if (!this.checkRequiredError()) {
        return;
      }

      this.filteredFromDate = this.$dateTime.getDateTime(this.selectedFromDate, 'yyyy-MM-dd');
      this.filteredToDate = this.$dateTime.getDateTime(this.selectedToDate, 'yyyy-MM-dd');

      this.filteredSystem = this.selectedSystem;
      this.filteredJobType = this.selectedJobType;

      this.filteredCustomers = this.selectedCustomers;

      this.loading = true;

      this.loadText = 'Getting TEUs by Job Type';
      var getChartJob = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.filteredFromDate}&end=${this.filteredToDate}&rptType=BY_JOBTYPE&sys=${this.filteredSystem.System.trim()}&jobType=${this.filteredJobType['Job Type'].trim()}&customerArray=${this.filteredCustomers.length == 0 ? '' : this.filteredCustomers.map((s) => { return s['Customer Code'] }).join(',')}`);
      this.TEUsJobItems = getChartJob.data;
      this.$refs.jobPie.loadPie();

      this.loadText = 'Getting TEUs by Container Type';
      var getChartContType = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.filteredFromDate}&end=${this.filteredToDate}&rptType=BY_CONTTYPE&sys=${this.filteredSystem.System.trim()}&jobType=${this.filteredJobType['Job Type'].trim()}&customerArray=${this.filteredCustomers.length == 0 ? '' : this.filteredCustomers.map((s) => { return s['Customer Code'] }).join(',')}`);
      this.TEUsContItems = getChartContType.data;
      this.$refs.contPie.loadPie();

      this.loadText = 'Getting Monthly Container Throughput';
      var getByMonth = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.filteredFromDate}&end=${this.filteredToDate}&rptType=BY_MONTH&sys=${this.filteredSystem.System.trim()}&jobType=${this.filteredJobType['Job Type'].trim()}&customerArray=${this.filteredCustomers.length == 0 ? '' : this.filteredCustomers.map((s) => { return s['Customer Code'] }).join(',')}`);
      this.monthlyThroughput = getByMonth.data;
      this.$refs.contChart.loadChart();

      // this.loadText = 'Getting Top 50 TEUs by Shipper/Consignee';
      // var getShprCsgn = await this.$apiCallV2(`/ContainerThroughput/GetContAnalysis?start=${this.filteredFromDate}&end=${this.filteredToDate}&rptType=BY_SHPRCSGN&sys=${this.filteredSystem.System.trim()}&jobType=${this.filteredJobType['Job Type'].trim()}&customerArray=${this.filteredCustomers.length == 0 ? '' : this.filteredCustomers.map((s) => { return s['Customer Code'] }).join(',')}&showTopx=50`);
      // this.top50ShprCsgn = getShprCsgn.data;
      // this.$refs.shprCsgn.loadChart();
      this.loadText = 'Getting Sales Analysis by Month (P&L txn only)';
      var plGetByMonth = await this.$apiCallV2(`/Sales/GetSalesAnalysis?start=${this.filteredFromDate}&end=${this.filteredToDate}&rptType=BY_MONTH_SALESPERSON`);
      this.top50ShprCsgn = plGetByMonth.data;

      this.loadText = 'Getting AR Collection Analysis by Month (P&L txn only)'; 
      var plGetByMonthCollection = await this.$apiCallV2(`/Sales/GetARCollectionAnalysis?start=${this.filteredFromDate}&end=${this.filteredToDate}&rptType=BY_MONTH_SALESPERSON`);
      
      this.salesBarKey = Object.keys(plGetByMonth.data[0]).map((k) => {
        if (k != 'Currency' && k != 'Month' && k != 'Month Name') {
          return k;
        } else {
          return '';
        }
      });
      this.salesBarKey = this.salesBarKey.filter((s) => { return s });

      this.salesLineKey = [];
      this.top50ShprCsgn.forEach((t, i) => {
        this.salesBarKey.forEach((s) => {
          t[s] = plGetByMonth.data[i][s] ? plGetByMonth.data[i][s].toFixed(2) : '0';
          t[`${s} Collection`] = plGetByMonthCollection.data[i][s] ? plGetByMonthCollection.data[i][s].toFixed(2) : '0';
        });
      });

      this.salesBarKey.forEach((b) => { this.salesLineKey.push(`${b} Collection`) });
      this.$refs.shprCsgn.loadChart();

      this.loading = false;

      this.lastRefreshed = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm');
    },
    checkRequiredError: function() {
      var errorCount = 0;

      if (!this.selectedSystem) {
        this.systemError = 'System is required';
        errorCount++;
      }

      if (!this.selectedJobType) {
        this.jobError = 'Job Type is required';
        errorCount++;
      }

      return errorCount == 0;
    },
    filterConfirm: function(e) {
      this.selectedCustomers = e;
    },
    monthlyThroughputContextMenu: function(menu, legend, details) {
      console.log(menu);
      console.log(legend);
      console.log(details);
    },
    contTypeContextMenu: function(menu, legend, details) {
      console.log(menu);
      console.log(legend);
      console.log(details);
    }
  },
  async mounted() {
    var year = new Date().getFullYear();
    var month = new Date().getMonth();
    var lastDate = new Date(year, month + 1, 0).getDate();

    this.selectedFromDate = new Date(year, 0, 1);
    this.selectedToDate = new Date(year, month, lastDate);

    this.loading = true;

    this.loadText = 'Getting Systems';
    var getSystem = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=SYSTEM`);
    this.systemItems = getSystem.data;
    this.selectedSystem = this.systemItems[0];

    this.loadText = 'Getting JobType';
    var getJobType = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=jobtype&modul=${this.selectedSystem.System.trim()}`);
    this.jobType.push({ '#': 1, 'Description': 'All', 'Job Type': '' });
    getJobType.data.forEach((j, i) => { this.jobType.push({ '#': i + 2, 'Description': j['Description'], 'Job Type': j['Job Type'] }) });
    this.selectedJobType = this.jobType[0];

    this.loadText = 'Getting Customers';
    var getCust = await this.$apiCallV2(`/ContainerThroughput/GetListMaster?masterFile=BILLCUSTNAME`);
    this.customerItems = getCust.data;

    this.loading = false;

    this.refreshClicked();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.fre-main {
  display: flex;
  padding: 5px 45px;
  font-size: 12px;

  > .left-container {
    height: 100%;
    min-width: 250px;
    max-width: 300px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;

    > .date-refresh-section {
      display: flex;
      align-items: center;

      > .from-to-date {
        flex-grow: 1;
      }

      > button {
        height: fit-content;
      }
    }

    > .customer-filter {
      height: calc(100% - 135px);
    }
  }

  > .right-container {
    height: 100%;
    width: calc(100% - 250px);
    display: flex;
    flex-direction: column;

    > .filter-section {
      width: 100%;
      display: flex;
      height: 85px;
      padding: 5px;
      background-color: white;
      border-radius: 5px;

      > .filtered-items {
        width: calc(100% - 250px);

        > .filtered-row {
          display: flex;
          align-items: center;

          > .filter-title {
            min-width: 60px;
          }

          > .colon-separator {
            margin: 0 5px;
          }

          > .filter-details {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      
      > .refresh-section {
        height: 100%;
        min-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;

        > button {
          width: fit-content;
          margin: 3px 0;
        }
      }
    }

    > .mid-chart-section {
      width: 100%;
      height: 50%;
      margin-top: 5px;
      display: flex;

      > .job-type-tues {
        width: 33%;
        height: 100%;
        background-color: white;
        border-radius: 5px;
        margin-right: 5px;
        padding: 5px;
      }

      > .cont-type-tues {
        width: 33%;
        height: 100%;
        background-color: white;
        border-radius: 5px;
        margin-right: 5px;
        padding: 5px;
      }

      > .cont-throughput {
        width: 34%;
        height: 100%;
        background-color: white;
        border-radius: 5px;
        padding: 5px;
      }
    }

    > .bottom-chart-section {
      width: 100%;
      height: calc(50% - 32px);
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      margin-top: 5px;
    }
  }
}
</style>